"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconCoverageFilled = function IconCoverageFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.14 20.35C42.0343 16.8103 39.917 13.6715 37.049 11.3207C34.1811 8.96977 30.6878 7.50954 27 7.12V6.12C27.0216 5.62672 26.8662 5.14197 26.5618 4.75322C26.2574 4.36447 25.8241 4.09732 25.34 4C25.0504 3.95001 24.7533 3.96446 24.4699 4.04232C24.1865 4.12019 23.9238 4.25955 23.7003 4.45051C23.4769 4.64146 23.2983 4.8793 23.1773 5.14712C23.0563 5.41493 22.9957 5.70613 23 6V7.12C19.3122 7.50954 15.8189 8.96977 12.951 11.3207C10.083 13.6715 7.96565 16.8103 6.86 20.35C6.83856 20.4251 6.83463 20.504 6.84852 20.5809C6.86241 20.6577 6.89374 20.7303 6.94012 20.7931C6.98649 20.8559 7.04666 20.9072 7.11599 20.9431C7.18531 20.9789 7.26195 20.9984 7.34 21H23V41.5C23 41.6326 22.9473 41.7598 22.8536 41.8536C22.7598 41.9473 22.6326 42 22.5 42C22.3674 42 22.2402 41.9473 22.1464 41.8536C22.0527 41.7598 22 41.6326 22 41.5V38.11C22.0192 37.6184 21.8626 37.136 21.5584 36.7494C21.2543 36.3627 20.8223 36.0971 20.34 36C20.0504 35.95 19.7533 35.9645 19.4699 36.0423C19.1865 36.1202 18.9238 36.2596 18.7003 36.4505C18.4769 36.6415 18.2983 36.8793 18.1773 37.1471C18.0563 37.4149 17.9957 37.7061 18 38V41.3C17.9759 42.4451 18.3763 43.5587 19.124 44.4264C19.8717 45.2941 20.9139 45.8546 22.05 46C22.6773 46.0615 23.3106 45.9908 23.9089 45.7925C24.5072 45.5942 25.0574 45.2727 25.5238 44.8486C25.9902 44.4246 26.3625 43.9076 26.6168 43.3308C26.8711 42.754 27.0016 42.1303 27 41.5V21H42.66C42.738 20.9984 42.8147 20.9789 42.884 20.9431C42.9533 20.9072 43.0135 20.8559 43.0599 20.7931C43.1063 20.7303 43.1376 20.6577 43.1515 20.5809C43.1654 20.504 43.1614 20.4251 43.14 20.35Z",
    fill: color
  }));
};

IconCoverageFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconCoverageFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconCoverageFilled;
exports.default = _default;